import {Fields, Model} from '@vuex-orm/core';
import Assignment from './Assignment';
import AssignmentPolicy from '../../assignment-policies/models/AssignmentPolicy';
import {RawCourseLikeAssignment} from '@/assignments/types/RawCourseLikeAssignment';

/**
 * Linking entity for assigning assignments to a CourseLike
 */
export class CourseLikeAssignment
  extends Model
  implements Omit<RawCourseLikeAssignment, 'assignment' | 'assignmentPolicies'>
{
  static entity = 'CourseLikeAssignment';

  id!: number;
  startDate!: string;
  dueDate!: string;
  createdAt!: string;
  pointValue!: number;
  visibleDate!: string;
  courseLikeId!: number;
  courseId!: number;
  assignmentId!: number;
  assignment!: Assignment;
  assignmentPolicies!: AssignmentPolicy[];
  isQuizMode!: boolean;
  quizModeReleaseDate!: string | null;
  preventPastDueSubmission!: boolean;

  static fields(): Fields {
    return {
      id: this.number(null),
      startDate: this.string(null),
      dueDate: this.string(null),
      createdAt: this.string(null),
      pointValue: this.number(1),
      visibleDate: this.string(null),
      courseLikeId: this.number(null),
      courseId: this.number(null),
      assignmentId: this.number(null),
      assignment: this.belongsTo(Assignment, 'assignmentId'),
      assignmentPolicies: this.hasMany(AssignmentPolicy, 'courseLikeAssignmentId'),
      isQuizMode: this.boolean(false),
      quizModeReleaseDate: this.string(null).nullable(),
      preventPastDueSubmission: this.boolean(false),
    };
  }
}

export default CourseLikeAssignment;
